import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import _get from 'lodash/get';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';
import VideoPlayer from '../components/VariantA/VideoPlayer';
import HeroContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },

    width: '100%',
    padding: '24px 5%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& button': {
      fontSize: 18,
      lineHeight: '23px',
      fontFamily: 'MadaBold',
    },
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
    },
  },
  textWrapper: {
    [theme.breakpoints.down('600')]: {
      marginBottom: 15,
    },
  },
  videoWrapper: {
    marginLeft: 80,
    '& video': {
      width: 390,
      height: 239,
      [theme.breakpoints.down('600')]: {
        width: '100%',
      },
    },
    '& img': {
      width: '100%',
      objectFit: 'fill',
    },
    [theme.breakpoints.down('800')]: {
      marginLeft: 20,
    },
    [theme.breakpoints.down('600')]: {
      width: '100%',
      marginLeft: 0,
    },
  },
}));

function VariantH() {
  const classes = useStyles();
  const { clientInfo } = useContext(HeroContext);
  const { introMedia, introVideo } = clientInfo[0];
  const imageSrc = _get(introMedia, 'url');
  return (
    <div className={classes.root} data-test-id="hero-variant-f">
      <Box display="flex" className={classes.container}>
        <div className={classes.textWrapper}>
          <Intro isLandingPage={false} />
          <GuideMeButton noGuideMe />
        </div>
        <div className={classes.videoWrapper}>
          <VideoPlayer url={introVideo.url} thumbnail={imageSrc} />
        </div>
      </Box>
    </div>
  );
}

export default VariantH;
